export default __webpack_public_path__ + "static/media/carwash2.0926e66b.png";